import { render } from "./tw-color-picker.vue?vue&type=template&id=2285f7e2"
import script from "./tw-color-picker.vue?vue&type=script&lang=js"
export * from "./tw-color-picker.vue?vue&type=script&lang=js"
script.render = render

export default script